import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import SwipeNavigation from './SwipeNavigation';
import PullToRefresh from '../common/PullToRefresh';
import TrialBanner from '../subscription/TrialBanner';
import { useTheme } from '../../context/ThemeContext';
import useNavigationDirection from '../../hooks/useNavigationDirection';
import { isIOS } from '../../services/native';

const ANIMATION_CLASS = {
  forward: 'animate-slide-in-forward',
  back: 'animate-slide-in-back',
  fade: 'animate-fade-in',
};

export default function Layout() {
  const location = useLocation();
  const { isModernUI } = useTheme();
  const direction = useNavigationDirection();

  // Detect if current route is a form page (add/edit)
  const isFormPage = /\/(new|edit|record-payment)/.test(location.pathname);

  return (
    <SwipeNavigation>
      <PullToRefresh disabled={isFormPage}>
        <div
          className={`min-h-screen ${isIOS ? 'safe-area-top' : ''} ${isModernUI ? 'transition-colors duration-300' : ''}`}
          style={{ backgroundColor: isModernUI ? 'var(--page-bg, #f8fafc)' : 'var(--page-bg, #f1f5f9)' }}
        >
          {/* iOS status bar overlay — fixed behind status bar so content scrolls under it */}
          {isIOS && (
            <div
              className="fixed top-0 left-0 right-0 z-[45] pointer-events-none xl:hidden"
              style={{
                height: 'var(--safe-area-top, 0px)',
                backdropFilter: 'saturate(180%) blur(20px)',
                WebkitBackdropFilter: 'saturate(180%) blur(20px)',
                backgroundColor: 'color-mix(in srgb, var(--page-bg, #f8fafc) 70%, transparent)',
              }}
            />
          )}

          {/* Trial/Subscription Banner */}
          <div className="xl:ml-72">
            <TrialBanner />
          </div>

          {/* Sidebar - Desktop */}
          <Sidebar />

          {/* Main Content */}
          <main className="xl:ml-72 pb-safe-nav xl:pb-8 min-h-screen overflow-x-hidden">
            <div
              key={location.pathname}
              className={isModernUI
                ? `px-4 xl:px-8 py-6 xl:py-8 ${ANIMATION_CLASS[direction]} xl:animate-fade-in`
                : `max-w-6xl mx-auto px-4 xl:px-8 py-8 ${ANIMATION_CLASS[direction]} xl:animate-fade-in`
              }
            >
              <Outlet />
            </div>
          </main>

          {/* Bottom Navigation - Mobile (hidden on form pages on iOS) */}
          {!(isIOS && isFormPage) && <BottomNav />}
        </div>
      </PullToRefresh>
    </SwipeNavigation>
  );
}
